import { DOCUMENT, isPlatformBrowser, isPlatformServer } from '@angular/common';
import { InjectionToken, PLATFORM_ID, inject } from '@angular/core';

export type PlatformToken = {
    isServer: boolean;
    isBrowser: boolean;
    isServerRendered: boolean;
    runOnBrowser: (sideEffectFn: () => void) => void;
    runOnServer: (sideEffectFn: () => void) => void;
};

export const PLATFORM = new InjectionToken<PlatformToken>('PLATFORM', {
    providedIn: 'platform',
    factory: () => {
        const platformId = inject(PLATFORM_ID);
        const document = inject(DOCUMENT);

        // eslint-disable-next-line unicorn/prefer-query-selector
        const isServerRendered = !!document.getElementById('ng-state');

        const isServer = isPlatformServer(platformId);
        const isBrowser = isPlatformBrowser(platformId);
        return {
            isServer,
            isBrowser,
            isServerRendered,
            runOnBrowser: (sideEffectFn: () => void) => isBrowser && sideEffectFn(),
            runOnServer: (sideEffectFn: () => void) => isServer && sideEffectFn(),
        };
    },
});
